export const ADMIN_BASE_PATH = '/admin/';

export const isOnAdminPath = (): boolean =>
  typeof window !== 'undefined' && window.location.pathname.startsWith(ADMIN_BASE_PATH);
